// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1264":"cb7a89d8","1381":"cb7a89d8","5545":"cb7a89d8"}[chunkId] + ".chunk.css";
};